import type { InsightsStatistics } from '../types/Insights';
import { useGet } from '../../../../api';

interface Params {
    diffInDays: string;
    environmentFilter: string;
    domainFilter: string[] | null;
}

const useGetInsightStatistics = ({ diffInDays, domainFilter, environmentFilter }: Params) => {
    const queryParams: Record<string, unknown> = {
        daysDiff: diffInDays
    };
    if (domainFilter) {
        queryParams.domainName = domainFilter;
    }
    if (environmentFilter) {
        queryParams.entitySourceType = environmentFilter;
    }
    const { data, fetchData, loading, error } = useGet<InsightsStatistics>({
        url: '/insights/statistics',
        queryParams: queryParams as Record<string, string>
    });

    return { data, isFetching: loading, error, fetchData };
};

export default useGetInsightStatistics;
